export default __webpack_public_path__ + "static/media/logo-full-dark.0b9b6bb0.png";